import cls from './WindowIcon.module.scss';

export const WindowIcon = () => {
  return (
    <svg
      className={cls.Icon}
      viewBox="0 0 48 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xlinkHref="http://www.w3.org/1999/xlink">
      <rect y="0.5" width="48" height="48" fill="url(#pattern0)" />
      <g>
        <path d="M2.86621 33.2703H0.0742188V45.282H2.86621V48.074H41.5639V45.282H44.8103V42.0355H47.4724V30.1534H44.8103V3.27269H41.5639V0.416016H8.7096V3.27269H5.85271V6.64923H2.86621V33.2703Z" />
      </g>
      <defs>
        <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlinkHref="#image0_909_29712" transform="scale(0.00833333)" />
        </pattern>
        <image
          id="image0_909_29712"
          width="120"
          height="120"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAB4CAYAAAA5ZDbSAAAAAXNSR0IArs4c6QAAAt5JREFUeJzt3TFu2lAcgPH3KmZQlh6gqpSZVpEQExcoG1foAcjGUrEwsvcCXdiiHIAubBygJ+gx3KVNRbGfUxtj8/n7TZGMsZVP/yhP2DhmWRaasFqtmnnjntlsNrHqvjHG8OaSJ6PuMTCcgeEMDGdgOAPDDersnFoKHQ6HOm/dK9PpNLW5bLmZXEY5wXAGhjMwnIHhDAxnYDgDwyXXwWUf+W2328Jtd3fvKp4Sz8PD++T28Xjc2LGdYDgDwxkYzsBwBoYzMFytjwtTS6GypcHT04c6h766Y/iZ3P44+3GlM/k/TjCcgeEMDGdgOAPDGRiu1jLpquK6eFv2pb336riOBk4EyBPX5ReXvry26rE/v/58OoTzJ/o1N1lWvhHzdnECKxcrcGpCezi9IdAC6wwvcN6k9nR6QyAG1glG4H+XSLHg57zXwjECqxAncN4U93x6QyAFVi5W4NSE9nB6Q6AF1hle4LxJ7en0hkAMHMJp0B7HDaGzHxdeQM/D/sGcYL0wMJyB4QwMZ2A4A8O1tkxK3a338YrnQdfJdfAx7xLVS65re7RG9k80nIHhDAxnYDgDw9X6L/r+/m3lfdfz9Jea3JrhcNj2KeRyguEMDGdgOAPDGRjOwHAGhkuug0ejUXLnkmfu6bey3+NisSjcttvtKu8bghOMZ2A4A8MZGM7AcAaGi1mWvAKtR5entWe1WhVuK3vsXWqZFGOMTjCcgeEMDGdgOAPDGRjOwHCD1GPcU49w1+Usl8vG3tsJhjMwnIHhDAxnYDgDw9W6u3AymRRu23/fp3f+eizcNPv2WPGMQtjvS47bgtls1tqxnWA4A8MZGM7AcAaGMzCcgeEa+67K+ad5+gXPDR13XnLcnnGC4QwMZ2A4A8MZGM7AcIPUF4Q0ebWf/krdQVj2JSvh/DHYJ5xgOAPDGRjOwHAGhjMwnIHh/Jad7kuuc5M7xugE0xkYzsBwBoYzMJyBpVv2Cxm4VpfiWJEoAAAAAElFTkSuQmCC"
        />
      </defs>
    </svg>
  );
};
